<div class="info-page">
  <h3>{{ actionLabel }} IRCP</h3>
</div>

<form [formGroup]="form">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Proposta Eleita</label>
      <textarea id="elected_proposal" class="form-control" rows="2" formControlName="elected_proposal" maxlength="255"></textarea>
      <app-field-message [field]="fieldMessageRequired('elected_proposal')" [erros]="fieldErros('elected_proposal')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Objetivo do projeto</label>
      <textarea id="ds_objective_project" class="form-control" rows="4" formControlName="ds_objective_project" maxlength="2500"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_objective_project')" [erros]="fieldErros('ds_objective_project')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Convenente:</label>
      <textarea id="ds_convenient" class="form-control" rows="4" formControlName="ds_convenient" maxlength="1000"></textarea>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Órgão executor:</label>
      <ng-select id="agency_id" class="ng-select-alternative" [items]="list?.orgaos" bindLabel="label" bindValue="id" placeholder="Selecione o Órgão" formControlName="agency_id" >
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">COREDE:</label>
      <ng-select id="corede_id" class="ng-select-alternative" [items]="list?.corede" bindLabel="label" bindValue="id"  formControlName="corede_id" (change)="selectCities($event)">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('corede_id')" [erros]="fieldErros('corede_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Município:</label>
      <ng-select id="city_id" class="ng-select-alternative" [items]="list?.city" bindLabel="label" bindValue="id" placeholder="Selecione o Município" formControlName="city_id">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Ano Votação:</label>
      <input id="year_ircp" class="form-control" maxlength="4" formControlName="year_ircp" placeholder="" mask="9999">
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Ano LOA:</label>
      <ng-select id="year_loa" class="ng-select-alternative" [items]="list?.year_loa" bindLabel="ano_base_orcamento" bindValue="ano_base_orcamento" placeholder="Selecione" formControlName="year_loa" (change)="anoLoa('year_loa', 'id_programa_tematico')">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">PPA Programa:</label>
      <ng-select id="id_programa_tematico" class="ng-select-alternative" [items]="list?.id_programa_tematico" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="id_programa_tematico" notFoundText="Selecione o Ano LOA" (change)="anoLoa('id_programa_tematico', 'id_programa')">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">PPA Ação Programática:</label>
      <ng-select id="id_programa" class="ng-select-alternative" [items]="list?.id_programa" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="id_programa" notFoundText="Selecione o PPA Programa" (change)="anoLoa('id_programa', 'ppa_nro_acao')">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">PPA Iniciativa:</label>
      <ng-select id="ppa_nro_acao" class="ng-select-alternative" [items]="list?.ppa_nro_acao" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="ppa_nro_acao" notFoundText="Selecione o PPA Ação Programática">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor de repasse:</label>
      <input id="transfer_value" class="form-control text-right" formControlName="transfer_value" (keyup)="maskCurrency($event, 'transfer_value')">
      <app-field-message [field]="fieldMessageRequired('transfer_value')" [erros]="fieldErros('transfer_value')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor de contrapartida:</label>
      <input id="counterpart_value" class="form-control text-right" formControlName="counterpart_value" (keyup)="maskCurrency($event, 'counterpart_value')">
      <app-field-message [field]="fieldMessageRequired('counterpart_value')" [erros]="fieldErros('counterpart_value')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor global:</label>
      <input id="global_value" class="form-control text-right" formControlName="global_value">
    </div>
  </div>

  <div class="form-group row m-b-lg">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Identificador no FPE:</label>
      <input id="fpe_identifier" class="form-control" formControlName="fpe_identifier" maxlength="10">
      <app-field-message [field]="fieldMessageRequired('fpe_identifier')" [erros]="fieldErros('fpe_identifier')"></app-field-message>
    </div>
  </div>

  <div *ngIf="entity">
    <app-detalhe-projeto-ircp-sei-list [idIrcp]="entity.id" [idProjeto]="idProjeto"></app-detalhe-projeto-ircp-sei-list>
  </div>
  <div *ngIf="entity">
    <app-detalhe-projeto-ircp-proa-list [idIrcp]="entity.id" [idProjeto]="idProjeto"></app-detalhe-projeto-ircp-proa-list>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Modalidade do instrumento de repasse:</label>
      <ng-select id="transfer_type_id" class="ng-select-alternative" [items]="list?.transfer_type" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="transfer_type_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('transfer_type_id')" [erros]="fieldErros('transfer_type_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Status operacional:</label>
      <ng-select id="operational_status_id" class="ng-select-alternative" [items]="list?.operational_status" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="operational_status_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('operational_status_id')" [erros]="fieldErros('operational_status_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável titular:</label>
      <ng-select id="manager" class="ng-select-alternative" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável adjunto:</label>
      <ng-select id="adjunct" class="ng-select-alternative" [multiple]="true" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="adjunct">
      </ng-select>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="this.entity?.id && this.permissions?.delete" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit" (click)="salvar()">Salvar</button>
    </div>
  </div>
</form>
<app-loading [loader]="isLoading"></app-loading>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<ng-container *ngIf="entity?.id">
  <app-aditivo-ircp-irfe-list [idIrcp]="entity?.id" [canSave]="canSave"></app-aditivo-ircp-irfe-list>
</ng-container>
